module.exports = __webpack_public_path__ + "img/page21_circle_03.f3b75ced.png";